export function retrieveCustomerContextCookieValue() {
  const customerContextCookie = retrieveCookieValueByName('customer_context');
  return customerContextCookie ? JSON.parse(customerContextCookie) : null;
}
export function retrieveCookieValueByName(name) {
  var _a;
  const cookie = (_a = document.cookie.split("; ").find(row => row.startsWith(`${name}=`))) === null || _a === void 0 ? void 0 : _a.split("=")[1];
  return cookie ? decodeURIComponent(cookie) : null;
}